import React from "react";

export default function Error({ error }) {
  return (
    <div
      className="html-viewer"
      style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "18px", marginBottom: "10px", color: "red" }}>Error: {error}</div>
      </div>
    </div>
  );
}
